import { combineReducers } from 'redux';
import contentReactions from './content-reactions-reducer';
import contentReactionDetails from './content-reaction-details-reducer';
import pendingContentReactions from './pending-content-reactions-reducer';

const reactionReducer = combineReducers({
  contentReactions,
  contentReactionDetails,
  pendingContentReactions,
});

export default reactionReducer;
